import axios from 'axios';

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.cookie.split("=")[1];

//const baseUrl = 'http://localhost:4810/Api';

export default {




    //********************************************************************| Authintecations |***********************************************************

    login(bodyObjeect) {
        return axios.post(`/Security/login`, bodyObjeect);
    },

    IsLoggedin() {
        return axios.get(`/Security/IsLoggedin`);
    },

    Logout() {
        return axios.post(`/Security/Logout`);
    },








    // ********************************| Start Dictionaries |******************************


    // PaymentMethods
    GetPaymentMethods(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/PaymentMethods/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllPaymentMethods() {
        return axios.get(`api/admin/Dictionaries/PaymentMethods/GetAll`);
    },

    AddPaymentMethods(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PaymentMethods/Add`, bodyObject);
    },

    EditPaymentMethods(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PaymentMethods/Edit`, bodyObject);
    },

    DeletePaymentMethods(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PaymentMethods/Delete`);
    },

    ChangeStatusPaymentMethods(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PaymentMethods/ChangeStatus`);
    },


    // Specialties
    GetSpecialties(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Specialties/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllSpecialties() {
        return axios.get(`api/admin/Dictionaries/Specialties/GetAll`);
    },

    AddSpecialties(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Specialties/Add`, bodyObject);
    },

    EditSpecialties(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Specialties/Edit`, bodyObject);
    },

    DeleteSpecialties(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Specialties/Delete`);
    },

    ChangeStatusSpecialties(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Specialties/ChangeStatus`);
    },

    // Specializations
    GetSpecializations(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Specializations/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllSpecializations() {
        return axios.get(`api/admin/Dictionaries/Specializations/GetAll`);
    },

    AddSpecializations(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Specializations/Add`, bodyObject);
    },

    EditSpecializations(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Specializations/Edit`, bodyObject);
    },

    DeleteSpecializations(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Specializations/Delete`);
    },

    ChangeStatusSpecializations(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Specializations/ChangeStatus`);
    },


    // DentalServices
    GetDentalServices(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/DentalServices/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllDentalServices() {
        return axios.get(`api/admin/Dictionaries/DentalServices/GetAll`);
    },

    AddDentalServices(bodyObject) {
        return axios.post(`api/admin/Dictionaries/DentalServices/Add`, bodyObject);
    },

    EditDentalServices(bodyObject) {
        return axios.post(`api/admin/Dictionaries/DentalServices/Edit`, bodyObject);
    },

    DeleteDentalServices(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/DentalServices/Delete`);
    },

    ChangeStatusDentalServices(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/DentalServices/ChangeStatus`);
    },






    GetDashboardInfo() {
        return axios.get(`api/admin/Dictionaries/Dashboard/Get`);
    },



    // ********************************| End Dictionaries |********************************















    ////Patients


















    // ********************************| Courses |************************************

    GetCourses(pageNo, pageSize, Search, IsFree, IsDiscount, SalesStatus, ViewStatus) {
        return axios.get(`api/admin/Courses/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
            &IsFree=${IsFree}&IsDiscount=${IsDiscount}&SalesStatus=${SalesStatus}&Status=${ViewStatus}`);
    },

    GetAllCourses() {
        return axios.get(`api/admin/Courses/GetAll`);
    },

    GetAllCoursesName() {
        return axios.get(`api/admin/Courses/GetNames`);
    },

    GetAllCoursesBySubjectSpecialization(SubjectId, AcademicSpecializationId) {
        return axios.get(`api/admin/Courses/GetBySubjectSpecialization?SubjectId=${SubjectId}&AcademicSpecializationId=${AcademicSpecializationId}`);
    },

    AddCourses(bodyObject) {
        return axios.post(`api/admin/Courses/Add`, bodyObject);
    },

    EditCourses(bodyObject) {
        return axios.post(`api/admin/Courses/Edit`, bodyObject);
    },

    DeleteCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/Delete`);
    },

    ChangeStatusCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/ChangeStatus`);
    },

    ChangeSalesStatusCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/ChangeSalesStatus`);
    },

    CloseCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/Close`);
    },

    AddTransferCoursesCourses(bodyObject) {
        return axios.post(`api/admin/Courses/TransferCourses`, bodyObject);
    },




    //Closed Course
    GetClosedCourses(pageNo, pageSize, Search, IsFree, IsDiscount) {
        return axios.get(`api/admin/Courses/GetClosed?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
            &IsFree=${IsFree}&IsDiscount=${IsDiscount}`);
    },

    OpenCourses(Id) {
        return axios.post(`api/admin/Courses/${Id}/Open`);
    },


    //ChartInfo
    GetAllCoursesChartInfo() {
        return axios.get(`api/admin/Courses/Chart/GetAll`);
    },


    //ChartInfo
    GetCoursesChartInfo(Id) {
        return axios.get(`api/admin/Courses/Chart/Get?Id=${Id}`);
    },


   





    //Shapters
    GetCourseShapters(Id, Search) {
        return axios.get(`api/admin/Courses/Shapters/Get?Id=${Id}&Search=${Search}`);
    },

    GetAllShapters(Id) {
        return axios.get(`api/admin/Courses/Shapters/GetAll?CourseId=${Id}`);
    },

    AddShapters(bodyObject) {
        return axios.post(`api/admin/Courses/Shapters/Add`, bodyObject);
    },

    EditShapters(bodyObject) {
        return axios.post(`api/admin/Courses/Shapters/Edit`, bodyObject);
    },

    DeleteShapters(Id) {
        return axios.post(`api/admin/Courses/${Id}/Shapters/Delete`);
    },

    ChangeStatusShapters(Id) {
        return axios.post(`api/admin/Courses/${Id}/Shapters/ChangeStatus`);
    },






    //Lectures
    GetCourseLectures(CourseId,ShapterId, Search) {
        return axios.get(`api/admin/Courses/Lectures/Get?CourseId=${CourseId}&ShapterId=${ShapterId}&Search=${Search}`);
    },

    AddLectures(bodyObject) {
        return axios.post(`api/admin/Courses/Lectures/Add`, bodyObject);
    },

    EditLectures(bodyObject) {
        return axios.post(`api/admin/Courses/Lectures/Edit`, bodyObject);
    },

    DeleteLectures(Id) {
        return axios.post(`api/admin/Courses/${Id}/Lectures/Delete`);
    },

    ChangeStatusLectures(Id) {
        return axios.post(`api/admin/Courses/${Id}/Lectures/ChangeStatus`);
    },






    //LecturesAttashments
    GetCourseLecturesAttashments(LectureId, Search) {
        return axios.get(`api/admin/Courses/LecturesAttashments/Get?LectureId=${LectureId}&Search=${Search}`);
    },

    AddLecturesAttashments(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Add`, bodyObject);
    },

    EditLecturesAttashments(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Edit`, bodyObject);
    },

    DeleteLecturesAttashments(Id) {
        return axios.post(`api/admin/Courses/${Id}/LecturesAttashments/Delete`);
    },

    ChangeStatusLecturesAttashments(Id) {
        return axios.post(`api/admin/Courses/${Id}/LecturesAttashments/ChangeStatus`);
    },


    //LecturesAttashments Vdocipher

    AddLecturesVdocipher(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Vdocipher/Add`, bodyObject);
    },

    EditLecturesVdocipher(bodyObject) {
        return axios.post(`api/admin/Courses/LecturesAttashments/Vdocipher/Edit`, bodyObject);
    },

    GetCourseLecturesAttashmentsShowVideo( Id) {
        return axios.get(`api/admin/Courses/LecturesAttashments/Vdocipher/ShowVideo?Id=${Id}`);
    },







    //Exams
    GetCourseExams(CourseId,ShapterId, Search) {
        return axios.get(`api/admin/Courses/Exams/Get?CourseId=${CourseId}&ShapterId=${ShapterId}&Search=${Search}`);
    },

    AddExams(bodyObject) {
        return axios.post(`api/admin/Courses/Exams/Add`, bodyObject);
    },

    EditExams(bodyObject) {
        return axios.post(`api/admin/Courses/Exams/Edit`, bodyObject);
    },

    DeleteExams(Id) {
        return axios.post(`api/admin/Courses/${Id}/Exams/Delete`);
    },

    ChangeStatusExams(Id) {
        return axios.post(`api/admin/Courses/${Id}/Exams/ChangeStatus`);
    },






    //ExamsQuestions
    GetCourseExamsQuestions(ExamId, Search) {
        return axios.get(`api/admin/Courses/ExamsQuestions/Get?ExamId=${ExamId}&Search=${Search}`);
    },

    AddExamsQuestions(bodyObject) {
        return axios.post(`api/admin/Courses/ExamsQuestions/Add`, bodyObject);
    },

    EditExamsQuestions(bodyObject) {
        return axios.post(`api/admin/Courses/ExamsQuestions/Edit`, bodyObject);
    },

    DeleteExamsQuestions(Id) {
        return axios.post(`api/admin/Courses/${Id}/ExamsQuestions/Delete`);
    },

    ChangeStatusExamsQuestions(Id) {
        return axios.post(`api/admin/Courses/${Id}/ExamsQuestions/ChangeStatus`);
    },


    //Students
    GetCourseStudents(Id, Search) {
        return axios.get(`api/admin/Courses/Students/Get?Id=${Id}&Search=${Search}`);
    },


    //Review
    GetCourseReview(Id, Search) {
        return axios.get(`api/admin/Courses/Review/Get?Id=${Id}&Search=${Search}`);
    },





    //// ********************************| End Courses |********************************







    // ********************************| Dentists |********************************



    GetDentists(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dentists/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllDentists() {
        return axios.get(`api/admin/Dentists/GetAll`);
    },

    AddDentists(bodyObject) {
        return axios.post(`api/admin/Dentists/Add`, bodyObject);
    },

    EditDentists(bodyObject) {
        return axios.post(`api/admin/Dentists/Edit`, bodyObject);
    },

    ChangeStatusDentists(Id) {
        return axios.post(`api/admin/Dentists/${Id}/ChangeStatus`);
    },

    ResetDeviceDentists(Id) {
        return axios.post(`api/admin/Dentists/${Id}/ResetDevice`);
    },

    ResetPasswordDentists(Id) {
        return axios.post(`api/admin/Dentists/${Id}/ResetPassword`);
    },

    DeleteDentists(Id) {
        return axios.post(`api/admin/Dentists/${Id}/Delete`);
    },

    //Clinics
    GetDentistsClinics(Id) {
        return axios.get(`api/admin/Dentists/Clinics/Get?Id=${Id}`);
    },

    AddDentistsClinics(bodyObject) {
        return axios.post(`api/admin/Dentists/Clinics/Add`, bodyObject);
    },

    DeleteDentistsClinics(Id) {
        return axios.post(`api/admin/Dentists/Clinics/${Id}/Delete`);
    },



    //Schedules
    GetDentistsSchedules(Id) {
        return axios.get(`api/admin/Dentists/Schedules/Get?Id=${Id}`);
    },

    AddDentistsSchedule(bodyObject) {
        return axios.post(`api/admin/Dentists/Schedules/Add`, bodyObject);
    },

    DeleteDentistsSchedule(Id) {
        return axios.post(`api/admin/Dentists/Schedules/${Id}/Delete`);
    },


    // ********************************| End Of Dentists |********************************





    // ********************************| Patients |********************************



    GetPatients(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Patients/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllPatients() {
        return axios.get(`api/admin/Patients/GetAll`);
    },

    AddPatients(bodyObject) {
        return axios.post(`api/admin/Patients/Add`, bodyObject);
    },

    EditPatients(bodyObject) {
        return axios.post(`api/admin/Patients/Edit`, bodyObject);
    },

    ChangeStatusPatients(Id) {
        return axios.post(`api/admin/Patients/${Id}/ChangeStatus`);
    },

    ResetDevicePatients(Id) {
        return axios.post(`api/admin/Patients/${Id}/ResetDevice`);
    },

    ResetPasswordPatients(Id) {
        return axios.post(`api/admin/Patients/${Id}/ResetPassword`);
    },

    DeletePatients(Id) {
        return axios.post(`api/admin/Patients/${Id}/Delete`);
    },

    //MedicalFiles
    GetPatientsMedicalFiles(Id) {
        return axios.get(`api/admin/Patients/MedicalFiles/Get?Id=${Id}`);
    },

    AddPatientsMedicalFiles(bodyObject) {
        return axios.post(`api/admin/Patients/MedicalFiles/Add`, bodyObject);
    },

    DeletePatientsMedicalFiles(Id) {
        return axios.post(`api/admin/Patients/MedicalFiles/${Id}/Delete`);
    },



    //Encounters
    GetPatientsEncounterss(Id) {
        return axios.get(`api/admin/Patients/Encounters/GetByPatients?Id=${Id}`);
    },

    DeleteEncountersSchedule(Id) {
        return axios.post(`api/admin/Patients/Encounters/${Id}/Delete`);
    },

    GetEncounters(pageNo,pageSize,Search) {
        return axios.get(`api/admin/Patients/Encounters/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AddEncounters(bodyObject) {
        return axios.post(`api/admin/Patients/Encounters/Add`, bodyObject);
    },


    AddDiagnoses(bodyObject) {
        return axios.post(`api/admin/Patients/Encounters/Diagnoses/Add`, bodyObject);
    },




    // ********************************| End Of Patients |********************************















    //// ********************************| Students |********************************


    GetStudents(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllStudents() {
        return axios.get(`api/admin/Students/GetAll`);
    },

    AddStudents(bodyObject) {
        return axios.post(`api/admin/Students/Add`, bodyObject);
    },

    EditStudents(bodyObject) {
        return axios.post(`api/admin/Students/Edit`, bodyObject);
    },

    ChangeStatusStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeStatus`);
    },

    ResetDeviceStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/ResetDevice`);
    },

    ResetPasswordStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/ResetPassword`);
    },

    DeleteStudents(Id) {
        return axios.post(`api/admin/Students/${Id}/Delete`);
    },

    //Suspends
    SuspendsStudents(bodyObject) {
        return axios.post(`api/admin/Students/Suspends/Add`, bodyObject);
    },

    GetSuspendsStudents(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/Suspends/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    CanselSuspends(Id) {
        return axios.post(`api/admin/Students/${Id}/Suspends/Cansel`);
    },





    //ChangeRequest
    GetChangeRequest(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/ChangeRequest/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AcceptChangeRequest(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeRequest/Accept`);
    },

    AcceptAllChangeRequest() {
        return axios.post(`api/admin/Students/ChangeRequest/AcceptAll`);
    },

    RejectChangeRequest(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeRequest/Reject`);
    },

    DeleteChangeRequest(Id) {
        return axios.post(`api/admin/Students/${Id}/ChangeRequest/Delete`);
    },

    DeleteAllChangeRequest() {
        return axios.post(`api/admin/Students/ChangeRequest/DeleteAll`);
    },





    //CoursesRequests
    GetCoursesRequests(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Students/CoursesRequests/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    AcceptCoursesRequests(Id) {
        return axios.post(`api/admin/Students/${Id}/CoursesRequests/Accept`);
    },

    RejectCoursesRequests(Id) {
        return axios.post(`api/admin/Students/${Id}/CoursesRequests/Reject`);
    },

    DeleteCoursesRequests(Id) {
        return axios.post(`api/admin/Students/${Id}/CoursesRequests/Delete`);
    },

    







    //Studetns Courses
    GetStudentsCourses(Id, Search) {
        return axios.get(`api/admin/Students/Courses/Get?Id=${Id}&Search=${Search}`);
    },

    AddStudentsCourses(bodyObject) {
        return axios.post(`api/admin/Students/Courses/Add`, bodyObject);
    },

    AddStudentsCoursesValue(bodyObject) {
        return axios.post(`api/admin/Students/Courses/AddValue`, bodyObject);
    },

    DropStudentsCourses(bodyObject) {
        return axios.post(`api/admin/Students/Courses/Drop`, bodyObject);
    },


     




    //Wallet
    GetStudentsWallet(Id) {
        return axios.get(`api/admin/Students/Wallet/Get?Id=${Id}`);
    },

    AddStudentsWalletValue(bodyObject) {
        return axios.post(`api/admin/Students/Wallet/Charge`, bodyObject);
    },






    //Devices
    GetStudentsDevices(Id) {
        return axios.get(`api/admin/Students/Devices/Get?Id=${Id}`);
    },


    GetAllStudentsChartInfo() {
        return axios.get(`api/admin/Students/Chart/GetAll`);
    },



    //// ********************************| End Of Students |********************************













    // ********************************| Clinics |********************************



    GetClinics(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Clinics/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllClinics() {
        return axios.get(`api/admin/Clinics/GetAll`);
    },

    AddClinics(bodyObject) {
        return axios.post(`api/admin/Clinics/Add`, bodyObject);
    },

    EditClinics(bodyObject) {
        return axios.post(`api/admin/Clinics/Edit`, bodyObject);
    },

    ChangeStatusClinics(Id) {
        return axios.post(`api/admin/Clinics/${Id}/ChangeStatus`);
    },

    ResetDeviceClinics(Id) {
        return axios.post(`api/admin/Clinics/${Id}/ResetDevice`);
    },

    ResetPasswordClinics(Id) {
        return axios.post(`api/admin/Clinics/${Id}/ResetPassword`);
    },

    DeleteClinics(Id) {
        return axios.post(`api/admin/Clinics/${Id}/Delete`);
    },

    //Suspends
    SuspendsClinics(bodyObject) {
        return axios.post(`api/admin/Clinics/Suspends/Add`, bodyObject);
    },

    GetSuspendsClinics(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Clinics/Suspends/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    CanselClinics(Id) {
        return axios.post(`api/admin/Clinics/${Id}/Suspends/Cansel`);
    },






    //Appointments
    GetAppointmentsClinics(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Clinics/Appointments/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAppointmentsRequest() {
        return axios.get(`api/admin/Clinics/Appointments/GetRequest`);
    },

    AcceptAppointmentsClinics(Id) {
        return axios.post(`api/admin/Clinics/${Id}/Appointments/Accept`);
    },

    RejectAppointmentsClinics(Id) {
        return axios.post(`api/admin/Clinics/${Id}/Appointments/Reject`);
    },

    CancelAppointmentsClinics(Id) {
        return axios.post(`api/admin/Clinics/${Id}/Appointments/Cancel`);
    },

    DeleteAppointmentsClinics(Id) {
        return axios.post(`api/admin/Clinics/${Id}/Appointments/Delete`);
    },








    GetClinicsPharmacies(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Clinics/Pharmacies/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllClinicsPharmacies() {
        return axios.get(`api/admin/Clinics/Pharmacies/GetAll`);
    },

    AddClinicsPharmacies(bodyObject) {
        return axios.post(`api/admin/Clinics/Pharmacies/Add`, bodyObject);
    },

    EditClinicsPharmacies(bodyObject) {
        return axios.post(`api/admin/Clinics/Pharmacies/Edit`, bodyObject);
    },

    ChangeStatusClinicsPharmacies(Id) {
        return axios.post(`api/admin/Clinics/${Id}/Pharmacies/ChangeStatus`);
    },

    ResetDeviceClinicsPharmacies(Id) {
        return axios.post(`api/admin/Clinics/${Id}/Pharmacies/ResetDevice`);
    },

    ResetPasswordClinicsPharmacies(Id) {
        return axios.post(`api/admin/Clinics/${Id}/Pharmacies/ResetPassword`);
    },

    DeleteClinicsPharmacies(Id) {
        return axios.post(`api/admin/Clinics/${Id}/Pharmacies/Delete`);
    },





    //EncountersDiagnoses
    GetClinicsEncountersDiagnoses(Id) {
        return axios.get(`api/admin/Clinics/EncountersDiagnoses/Get?PharmaciesId=${Id}`);
    },

    AcceptEncountersDiagnoses(Id) {
        return axios.post(`api/admin/Clinics/${Id}/EncountersDiagnoses/Accept`);
    },

    RejectEncountersDiagnoses(Id) {
        return axios.post(`api/admin/Clinics/${Id}/EncountersDiagnoses/Reject`);
    },

    DeleteEncountersDiagnoses(Id) {
        return axios.post(`api/admin/Clinics/${Id}/EncountersDiagnoses/Delete`);
    },












    // ********************************| End Of Clinics |********************************












    // ********************************| Financial |********************************

    GetSubscriptions(pageNo, pageSize, Search, From, To) {
        return axios.get(`api/admin/Financial/GetSubscriptions?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}`);
    },

    GetRecharge(pageNo, pageSize, Search, From, To, UserId, DistributorsId, PaymentMethodId) {
        return axios.get(`api/admin/Financial/GetRecharge?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}&UserId=${UserId}&DistributorsId=${DistributorsId}&PaymentMethodId=${PaymentMethodId}`);
    },

    GetWalletTracker(pageNo, pageSize, Search, From, To, ProcessType, Channel) {
        return axios.get(`api/admin/Financial/GetWalletTracker?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}
        &From=${From}&To=${To}&ProcessType=${ProcessType}&Channel=${Channel}`);
    },





    // ********************************| End Of Financial |********************************














    // ********************************| VoucherCards |********************************

    GetVoucherCards(pageNo, pageSize, Search, DistributorsId) {
        return axios.get(`api/admin/VoucherCards/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}&DistributorsId=${DistributorsId}`);
    },

    AddVoucherCards(bodyObject) {
        return axios.post('api/admin/VoucherCards/Add', bodyObject);
    },

    SaleVoucherCards(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Sale`, { responseType: 'blob' });
    },

    ForzePackage(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Freeze`, { responseType: 'blob' });
    },

    DeletePackage(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Delete`);
    },



    //Card
    GetCards() {
        return axios.get(`api/admin/VoucherCards/Cards/Get`);
    },

    GetCardInfoBySerialNumber(SerialNumber) {
        return axios.get(`api/admin/VoucherCards/Cards/GetCardInfoBySerialNumber?SerialNumber=${SerialNumber}`);
    },

    GetCardInfoByVoucherNumber(VoucherNumber) {
        return axios.get(`api/admin/VoucherCards/Cards/GetCardInfoByVoucherNumber?SerialNumber=${VoucherNumber}`);
    },


    //TryAttemp
    GetVoucherCardsTryAttemp(pageNo, pageSize, Search) {
        return axios.get(`api/admin/VoucherCards/TryAttemp/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },



    //Chart
    GetVoucherCardsChart() {
        return axios.get(`api/admin/VoucherCards/Chart/Get`);
    },



    


    //Distributors
    GetDistributors(pageNo, pageSize, Search) {
        return axios.get(`api/admin/VoucherCards/Distributors/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllDistributors() {
        return axios.get(`api/admin/VoucherCards/Distributors/GetAll`);
    },

    AddDistributors(bodyObject) {
        return axios.post('api/admin/VoucherCards/Distributors/Add', bodyObject);
    },

    EditDistributors(bodyObject) {
        return axios.post('api/admin/VoucherCards/Distributors/Edit', bodyObject);
    },

    ResetPasswordDistributors(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Distributors/ResetPassword`);
    },

    ChangeStatusDistributors(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Distributors/ChangeStatus`);
    },

    DeleteDistributors(Id) {
        return axios.post(`api/admin/VoucherCards/${Id}/Distributors/Delete`);
    },




    ActivePackgeDistributors(bodyObject) {
        return axios.post('api/admin/VoucherCards/Distributors/ActivePackge', bodyObject);
    },

    GetDistributorsPackages(pageNo, pageSize) {
        return axios.get(`api/admin/VoucherCards/Distributors/Packages/Get?pageNo=${pageNo}&pagesize=${pageSize}`);
    },

    // ********************************| End Of VoucherCards |********************************












    // ********************************| Users |********************************
    GetUsers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Users/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetUsersTransactions(pageNoT, pageSizeT, Id) {
        return axios.get(`api/admin/Users/GetTransactions?pageNo=${pageNoT}&pagesize=${pageSizeT}&Id=${Id}`);
    },

    GetAllUsers() {
        return axios.get(`api/admin/Users/GetAll`);
    },

    AddUsers(bodyObject) {
        return axios.post('api/admin/Users/Add', bodyObject);
    },

    EditUsers(bodyObject) {
        return axios.post('api/admin/Users/Edit', bodyObject);
    },

    ResetPasswordUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ResetPassword`);
    },

    ChangeStatusUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ChangeStatus`);
    },

    DeleteUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/Delete`);
    },


    //USerProfile 
    ChangeProfilePicture(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePicture', bodyObject);
    },

    ChangeProfileInfo(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangeInfo', bodyObject);
    },

    ChangeProfilePassword(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePassword', bodyObject);
    },




    // ********************************| End Of Users |********************************




    
    
}